import { z } from 'zod';
import superjson from 'superjson';
export const schema = z.object({
  category: z.string().min(1).max(50).optional(),
});

export type InputType = z.infer<typeof schema>;

export type PersonaWithSettings = {
  id: string;
  name: string;
  description: string | null;
  icon: string;
  category: string;
  systemPrompt: string;
  isBuiltin: boolean;
  priority: number;
  tags: string[] | null;
  visibility?: string | null;
  createdBy?: number | null;
  isEnabled: boolean;
  customPriority: number | null;
};

export type OutputType = {
  personas: PersonaWithSettings[];
};

export const getPersonasList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams();
  if (input.category) params.append('category', input.category);

  const url = params.toString() ? `/_api/personas/list?${params}` : '/_api/personas/list';

  const result = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
